/**
 * A higher order function to debounce a function execution
 * @param  integer  delay    Required - how long to "hold" the function for
 * @param  function callback Required - the function to be called at the end of the delay period
 * @return function
 */
module.exports = (delay, callback) => {
    var timeout;
    return function() {
        var context = this, args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(function() {
            timeout = null; callback.apply(context, args);
        }, delay);
    };
};